import { Vault } from '@/features/vaults/types';

export const ethereumTestKeyrock3VaultId = 'ethereum-test-keyrock-3-1';

export const ethereumTestKeyrock3: Vault = {
  id: ethereumTestKeyrock3VaultId,
  type: 'core-vault',
  name: 'test Keyrock 3',
  description: '',
  category: 'core-vault',
  address: '0xBE2709B4246F7ad280b276077C608afD4BEd11cA',
  curators: [],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0xBE2709B4246F7ad280b276077C608afD4BEd11cA',
    },
  ],
  baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  lpTokenSymbol: 'tKR3-1',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: true,
  },
  archived: false,
  prioritizedQueues: [
    '0x03157861226283384B6E22812bB9C19BA5b88d15', // USDC SyncDepositQueue
  ],
};
